export const TrustIndicators = ({
  isMobile = false,
}: {
  isMobile?: boolean;
}) => {
  const baseImagePath = `/dashboard/trust-indicators/${isMobile ? "mobile" : "desktop"}`;
  const indicators = [
    {
      icon: `${baseImagePath}/review.svg`,
      label: "4.8/5",
      subLabel: "25k+ Happy Customers",
    },
    {
      icon: `${baseImagePath}/shield.svg`,
      label: "Trusted",
      subLabel: "since 2015",
    },
    {
      icon: `${baseImagePath}/transaction.svg`,
      label: "50k+",
      subLabel: "Successful Transactions",
    },
  ];
  return (
    <div className="flex flex-col xl:flex-row justify-center gap-8 text-sm text-black xl:text-white w-fit">
      {indicators.map((indicator, index) => (
        <div key={index} className="flex items-center gap-2">
          <div className="bg-custom-light-blue/20 xl:bg-black/20 rounded-full p-3">
            <img src={indicator.icon} alt="" className="w-8 h-8" />
          </div>

          <div className="flex flex-col">
            <span className="text-[32px] font-extrabold">
              {indicator.label}
            </span>
            <span className="font-normal text-base">{indicator.subLabel}</span>
          </div>
        </div>
      ))}
    </div>
  );
};
